module.exports = __webpack_public_path__ + "static/media/rediseg-login@2x.dbc1ba4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/rediseg-login@2x.png
// module id = 1058
// module chunks = 0